import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

interface DashboardStats {
  totalUsers: number;
  activeMeetings: number;
  completedMeetings: number;
  avgDuration: number;
}

interface RecentMeetingStats {
  id: string;
  title: string;
  start_time: string;
  end_time: string;
  meeting_date: string;
  participantDetails: [];
  created_by:
    {
      first_name: string;
      last_name: string;
      email: string;
    }
  

}

interface TopUserStats {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  meeting_count: number;
  department: string | null;
  job_title: string | null;
  avatarurl: string | null;
}

interface AllUserStats {
  id: string;
  Name: string;
  Email: string;
  Department: string | null;
  job_title: string | null;
  isAdmin: boolean;
  Created_at: string;
  avatarUrl: string | null;
  last_login_at: string | null;
  phone_number: string | null;  // FIXED
  location: string | null;      // FIXED
}
interface NewUserInput {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  department?: string;
  job_title?: string;
  isAdmin?: boolean;
  phone_number?: string; 
  location?: string;
}

interface AdminContextType {
  stats: DashboardStats;
  loading: boolean;
  error: string | null;
  refreshStats: () => Promise<void>;
  recentMeetings: RecentMeetingStats[];
  fetchRecentMeetings: () => Promise<void>;
  topUsers: TopUserStats[];
  fetchTopUsers: () => Promise<void>;
  allUsers: AllUserStats[];
  fetchAllUserData: () => Promise<void>;
  addUser: (input: NewUserInput) => Promise<void>;
  deleteUser: (userId: string) => Promise<void>;
  editUser: (userId: string, input: NewUserInput) => Promise<void>;
  updateUserPassword: (userId: string, password: string) => Promise<void>;
  meetingAnalytics: {
    totalMeetings: number;
    avgDurationMin: number;
    totalParticipants: number;
    avgParticipants: number;
    peakHour: string;
    completionRate: number;
    rescheduleRate: number;
    cancelRate: number;
    byPeriod: number[];
  } | null;
  topMeetingRooms: Array<{
    name: string;
    meetings: number;
    avgDurationMin: number;
    participants: number;
    completionRate: number;
    rescheduledCount: number;
  }>;
  fetchMeetingAnalytics: (rangeDays: number) => Promise<void>;
  fetchTopMeetingRooms: () => Promise<void>;
  generalSettings: {
    session_timeout_minutes: number;
    password_expiration_days: number;
    enforce_two_factor: boolean;
    enable_email_notifications: boolean;
    enable_system_alerts: boolean;
    allow_guest_access: boolean;
    announcement_title: string | null;
    announcement_message: string | null;
    announcement_severity: string | null;
    announcement_audience: string | null;
    announcement_expires_at: string | null;
    is_session_expiry_enabled: boolean;
    is_password_expiry_enabled: boolean;
  } | null;
  fetchGeneralSettings: () => Promise<void>;
  updateGeneralSettings: (updates: Partial<AdminContextType["generalSettings"]>) => Promise<void>;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const useAdmin = (): AdminContextType => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error("useAdmin must be used within an AdminProvider");
  }
  return context;
};

interface AdminProviderProps {
  children: ReactNode;
}

// 👇 FIXED HERE — ensure we use an explicit return statement
export const AdminProvider: React.FC<AdminProviderProps> = ({ children }) => {
  const [stats, setStats] = useState<DashboardStats>({
    totalUsers: 0,
    activeMeetings: 0,
    completedMeetings: 0,
    avgDuration: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [recentMeetings, setRecentMeetings] = useState<RecentMeetingStats[]>([]);
  const [topUsers, setTopUsers] = useState<TopUserStats[]>([]);
  const [allUsers, setAllUsers] = useState<AllUserStats[]>([]);
  const [meetingAnalytics, setMeetingAnalytics] = useState<AdminContextType["meetingAnalytics"]>(null);
  const [topMeetingRooms, setTopMeetingRooms] = useState<AdminContextType["topMeetingRooms"]>([]);
  const [generalSettings, setGeneralSettings] = useState<AdminContextType["generalSettings"]>(null);
  console.log("topmeetingrooms",topMeetingRooms);
  
  console.log("allUsers", allUsers);
  const {user}=useAuth();
  // console.log('userrrrr',user?.isAdmin);
  
  
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://vela-back.wingtrill.com';


  const fetchStats = async () => {

    try {
      setLoading(true);
          const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/stats`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
      // const { data } = await axios.get("/api/admin/stats");
      const data = await response.json();
      console.log('Admin stats:', data);
      
      setStats(data);
      setError(null);
    } catch (err) {
      console.error("Failed to load admin statistics", err);
      setError("Failed to load admin statistics");
    } finally {
      setLoading(false);
    }
  };

  const fetchRecentMeetings = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/recent-meetings`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    console.log('Recent meetings response:', data);

    //  Fix: Ensure we store only the array
    const meetingsArray = Array.isArray(data)
      ? data
      : Array.isArray(data.meetings)
      ? data.meetings
      : [];

    setRecentMeetings(meetingsArray);
    setError(null);
  } catch (err) {
    console.error("Failed to load recent meetings", err);
    setError("Failed to load recent meetings");
  } finally {
    setLoading(false);
  }
};

 const fetchTopUsers = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/top-users`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    console.log('Top users response:', data);

    //  Fix: Ensure we store only the array
    const usersArray = Array.isArray(data)
      ? data
      : Array.isArray(data.topUsers)
      ? data.topUsers
      : [];

    setTopUsers(usersArray);
    setError(null);
  } catch (err) {
    console.error("Failed to load top users", err);
    setError("Failed to load top users");
  } finally {
    setLoading(false);
  }
};

const fetchAllUserData = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/all-users`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    console.log('All users response:', data);

    //  Fix: Ensure we store only the array
    const usersArray = Array.isArray(data)
      ? data
      : Array.isArray(data.users)
      ? data.users
      : [];
    setAllUsers(usersArray);
    console.log("allUsersusersArray", usersArray);
    
    setError(null);
  } catch (err) {
    console.error("Failed to load all users", err);
    setError("Failed to load all users");
  } finally {
    setLoading(false);
  }
};

const fetchMeetingAnalytics = async (rangeDays: number) => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');
    const response = await fetch(`${backendUrl}/api/admin/meeting-analytics?range=${rangeDays}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    setMeetingAnalytics(data);
    setError(null);
  } catch (err) {
    console.error('Failed to load meeting analytics', err);
    setError('Failed to load meeting analytics');
  } finally {
    setLoading(false);
  }
};

const fetchTopMeetingRooms = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');
    const response = await fetch(`${backendUrl}/api/admin/top-meeting-rooms`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    const roomsArray = Array.isArray(data?.rooms) ? data.rooms : [];
    setTopMeetingRooms(roomsArray);
    setError(null);
  } catch (err) {
    console.error('Failed to load top meeting rooms', err);
    setError('Failed to load top meeting rooms');
  } finally {
    setLoading(false);
  }
};

const fetchGeneralSettings = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');
    const response = await fetch(`${backendUrl}/api/admin/general-settings`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    setGeneralSettings(data?.settings || null);
    setError(null);
  } catch (err) {
    console.error('Failed to load general settings', err);
    setError('Failed to load general settings');
  } finally {
    setLoading(false);
  }
};

const updateGeneralSettings = async (updates: Partial<AdminContextType["generalSettings"]>) => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');
    const response = await fetch(`${backendUrl}/api/admin/general-settings`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    console.log("updated settingsss",updates);
    
    const data = await response.json();
    setGeneralSettings(data?.settings || null);
    setError(null);
  } catch (err) {
    console.error('Failed to update general settings', err);
    setError('Failed to update general settings');
  } finally {
    setLoading(false);
  }
};

const addUser = async (input: NewUserInput) => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/add-users`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(input),
    });
    if (!response.ok) throw new Error('Failed to add user');
    const data = await response.json();
    console.log('Add user response:', data);
    setError(null);
     fetchStats();
    fetchRecentMeetings();
    fetchTopUsers();
    fetchAllUserData();
  } catch (err) {
    console.error("Failed to add user", err);
    setError("Failed to add user");
  } finally {
    setLoading(false);
  }
};

const deleteUser = async (userId: string) => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/delete-users/${userId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to delete user');
    const data = await response.json();
    console.log('Delete user response:', data);
    setError(null);
     fetchStats();
    fetchRecentMeetings();
    fetchTopUsers();
    fetchAllUserData();
  } catch (err) {
    console.error("Failed to delete user", err);
    setError("Failed to delete user");
  } finally {
    setLoading(false);
  }
};

const editUser= async (userId: string, input: NewUserInput) => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/edit-users/${userId}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(input),
    });
    if (!response.ok) throw new Error('Failed to edit user');
    const data = await response.json();
    console.log('Edit user response:', data);
    setError(null);
     fetchStats();
    fetchRecentMeetings();
    fetchTopUsers();
    fetchAllUserData();
  } catch (err) {
    console.error("Failed to edit user", err);
    setError("Failed to edit user");
  } finally {
    setLoading(false);
  }
};

const updateUserPassword = async (userId: string, password: string) => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) throw new Error('Authentication required');

    const response = await fetch(`${backendUrl}/api/admin/update-user-password/${userId}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password }),
    });
    if (!response.ok) throw new Error('Failed to update password');
    const data = await response.json();
    console.log('Update password response:', data);
    setError(null);
     fetchStats();
    fetchRecentMeetings();
    fetchTopUsers();
    fetchAllUserData();
  } catch (err) {
    console.error("Failed to update password", err);
    setError("Failed to update password");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if(!user?.isAdmin) return;
    fetchStats();
    fetchRecentMeetings();
    fetchTopUsers();
    fetchAllUserData();
    fetchMeetingAnalytics(7);
    fetchTopMeetingRooms();
    fetchGeneralSettings();
  }, []);

  //  Make sure to return JSX here
  return (
    <AdminContext.Provider value={{ stats, loading, error, refreshStats: fetchStats,recentMeetings,fetchRecentMeetings,topUsers,fetchTopUsers,allUsers,fetchAllUserData,addUser,deleteUser,editUser,updateUserPassword, meetingAnalytics, topMeetingRooms, fetchMeetingAnalytics, fetchTopMeetingRooms, generalSettings, fetchGeneralSettings, updateGeneralSettings }}>
      {children}
    </AdminContext.Provider>
  );
};
